import {
  ConfirmModalArgs,
  useConfirmModal,
} from '@/components/ConfirmationModal';
import { useTranslation } from '@/i18n';
import { useCallback, useMemo, useState } from 'react';

type RecordInfo = {
  code: string;
  label: string;
};

export const useConfirmDeleteOption = () => {
  const { t } = useTranslation();
  const [currentRecord, setCurrentRecord] = useState<RecordInfo | null>(null);

  const args: ConfirmModalArgs = useMemo(
    () => ({
      title: t('transaction_items.detail.options.delete_confirm.title', {
        label: currentRecord?.label,
      }),
      body: t('transaction_items.detail.options.delete_confirm.message'),
      cancelButtonProps: {
        isTertiary: true,
        children: t('cancel'),
      },
      okButtonProps: {
        isSecondary: true,
        color: 'danger',
        children: t('delete'),
      },
      size: 'md',
    }),
    [t, currentRecord]
  );

  const { confirm: originalConfirm, ConfirmModal } = useConfirmModal(args);

  const confirm = useCallback(
    async (recordInfo?: RecordInfo): Promise<boolean> => {
      if (recordInfo) {
        setCurrentRecord(recordInfo);
      }
      const result = await originalConfirm();
      setCurrentRecord(null);
      return result;
    },
    [originalConfirm]
  );

  return { confirm, ConfirmModal };
};
